import { render, staticRenderFns } from "./RegisterSongStep0SelectACatalog.vue?vue&type=template&id=7fadf8b4&scoped=true"
import script from "./RegisterSongStep0SelectACatalog.vue?vue&type=script&lang=ts"
export * from "./RegisterSongStep0SelectACatalog.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSongStep0SelectACatalog.vue?vue&type=style&index=0&id=7fadf8b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fadf8b4",
  null
  
)

export default component.exports